export const siteConfig = {
  name: '淫字文化溯源',
  tagline: '汉字文化溯源与语义演变全解',
  description: '深度解析「淫」字的字形演变、本义引申、古籍用法及现代语境，帮助读者全面理解这一汉字的语言学价值与文化意义。',
  url: 'https://yiyanse.github.io',
  logo: '淫',
  foundingYear: 2024,
  email: 'contact@yinziyuan.com',
  socialLinks: {
    weibo: '#',
    wechat: '#',
    zhihu: '#',
  },
};

export const aboutContent = {
  brandIntro: {
    title: '关于淫字文化溯源',
    content: `<p>「淫字文化溯源」是一个专注于汉字文化深度研究的学术型知识平台。我们以「淫」字为切入点，通过对一个汉字的全方位考察——字形演变、语义分析、古籍用例、文化意蕴——展现中华文字体系的博大精深。</p>
<p>本站汇聚了来自古文字学、语言学、文献学、文化研究等多个领域的学术成果，以通俗易懂的文字，将专业的汉字学知识传递给广大读者。我们相信，每一个汉字都是一扇通往中华文化深处的窗口。</p>
<p>自2024年创立以来，本站已累计发布原创研究文章十余篇，涵盖字形演变、语义解析、古籍用例、文化研究、现代语境五大板块，为汉字爱好者提供了一个系统了解「淫」字文化的优质平台。</p>`,
  },
  reputation: {
    title: '学术声誉与评价',
    items: [
      {
        quote: '「淫字文化溯源」以一个汉字为窗口，展现了汉语词汇语义学的精彩世界。文章学术严谨，文字通俗，是汉字文化普及的典范之作。',
        author: '李天枢',
        role: '北京大学中文系教授',
      },
      {
        quote: '将专业学术研究成果转化为大众可理解的阅读内容，需要深厚的学养和高超的表达能力。「淫字文化溯源」在这方面做得非常出色。',
        author: '赵文博',
        role: '《汉字文化》杂志主编',
      },
      {
        quote: '多次向我的学生推荐这个网站。它把复杂的文字学问题讲得清晰透彻，是古汉语教学和研究的优秀参考资源。',
        author: '张令仪',
        role: '复旦大学出土文献与古文字研究中心研究员',
      },
    ],
  },
  contact: {
    title: '联系我们',
    description: '如果您对本站内容有任何建议、意见，或者希望进行学术交流与合作，欢迎通过以下方式与我们联系。',
    email: 'contact@yinziyuan.com',
    wechat: 'yinziyuan2024',
    address: '北京市海淀区中关村大街59号',
  },
};